import { jsx as o, jsxs as c } from "react/jsx-runtime";
import { c as n } from "../../../clsx-OuTLNxxd.js";
import { I as r } from "../../../icon-BnqXyiyH.js";
import "../icon/iconsList.js";
const _ = "_stepper_s25yg_29", d = "_horizontal_s25yg_33", p = "_vertical_s25yg_38", s = {
  stepper: _,
  horizontal: d,
  vertical: p,
  "step-container": "_step-container_s25yg_43",
  "step-number": "_step-number_s25yg_58",
  "is-disabled": "_is-disabled_s25yg_72",
  "is-done": "_is-done_s25yg_77",
  "step-label": "_step-label_s25yg_82",
  "step-connector": "_step-connector_s25yg_102",
  "dialog-overlay-show": "_dialog-overlay-show_s25yg_1",
  "dialog-content-show": "_dialog-content-show_s25yg_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_s25yg_1"
};
function b({ steps: t, orientation: a = "vertical", className: l }) {
  return /* @__PURE__ */ o("div", { className: n(l, s.stepper, s[a]), children: t.map((e, i) => /* @__PURE__ */ c("div", { className: s["step-container"], children: [
    /* @__PURE__ */ o(
      "span",
      {
        className: n(
          s["step-number"],
          e.isDisabled && s["is-disabled"],
          e.isDone && s["is-done"]
        ),
        children: e.isDone ? /* @__PURE__ */ o(r, { name: "check", color: "success", size: "medium" }) : i + 1
      }
    ),
    /* @__PURE__ */ o(
      "span",
      {
        className: n(
          s["step-label"],
          e.isDone && s["is-done"],
          e.isDisabled && s["is-disabled"]
        ),
        children: e.content
      }
    ),
    (i < t.length - 1 || a === "vertical") && /* @__PURE__ */ o("div", { className: s["step-connector"] })
  ] }, `step-${i + 1}`)) });
}
export {
  b as ProgressSteps
};
